import axios from "axios";
import { SERVERPATH } from "./index";

const EKYCPath = `${SERVERPATH}/ekyc`;

export async function ekycInitiate(payload) {
    const response = await axios.post(`${EKYCPath}/initiate`, payload);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    return responseData;
}

export async function getEKYCStatus() {
    const response = await axios.get(`${EKYCPath}/status`);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    const { status: ocStatus, data } = responseData;

    if (ocStatus !== 200) {
        throw responseData;
    }

    return data;
}

export async function getEKYCLink() {
    const response = await axios.get(`${EKYCPath}/links`);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    const { status: ocStatus, data } = responseData;

    if (ocStatus !== 200) {
        throw responseData;
    }

    return data;
}

export async function updateEKYCProfile(payload) {
    const response = await axios.patch(`${EKYCPath}/profile`, payload);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    return responseData;
}
